export default __webpack_public_path__ + "static/media/RescheduleIcon.19cd4e9a.svg";